import OfferCard from './OfferCard';
import offersAdapter from './helpers/offersAdapter';
import checkPermissions from './helpers/checkPermissions';

export default OfferCard;

export { offersAdapter, checkPermissions };
